import { useContext } from "react";
import { ToolContext } from "../../../../../core/context/ToolContext";
import { ProductDetails } from "./ProductDetails"
import { Variation } from "./Variation"
import { Modal, Box, Stack, Typography, Grid } from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';

export const Form = ({ showModal }) => {
	const { setup_state } = useContext(ToolContext);
    const { prdctModalForm } = setup_state;

	return (
		<Modal open={prdctModalForm.data.toggled} sx={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
			<Box bgcolor="#fff" width="80%" height="95vh" borderRadius="8px" p="1.5rem" className="overflowY">
				<Stack flexDirection="row" justifyContent="space-between">
					<Typography fontSize="22px" fontWeight="600">Add Product</Typography>
					<CloseIcon onClick={() => showModal(false)} sx={{ cursor: "pointer", transition: "0.25s" , "&:hover": { backgroundColor: "#f0f2f4" } }}/>
				</Stack>
				<Typography mt="0.5rem" fontWeight="500"> Product Details </Typography>
				<Grid container spacing={2}>
					<ProductDetails/>
					<Variation/>
				</Grid>
			</Box>
		</Modal>
	)
}
